import * as authLib from '../api/auth.js';
import * as cache from '../cache.js';
import { fetchLoadable } from '../fetchLoadable.js';
import { clearStorage, dispatch, setAuthToken } from '../internal.js';
import * as actionTypes from './actionTypes.js';
export const setToken = (token) => {
    setAuthToken(token);
    dispatch({ type: actionTypes.SET_TOKEN, payload: { token } });
};
export const login = (email, password) => fetchLoadable(actionTypes.LOGIN, authLib.login, { email, password });
export const ssoLogin = (email) => fetchLoadable(actionTypes.LOGIN, authLib.ssoLogin, { email });
export const verifyTwoFactor = (username, password, token) => fetchLoadable(actionTypes.VERIFY_TWO_FACTOR, authLib.verifyTwoFactor, {
    username,
    password,
    token,
});
export const reset = () => dispatch({ type: actionTypes.RESET_TOKEN });
export const createPassword = (token, password) => fetchLoadable(actionTypes.CREATE_PASSWORD, authLib.createPassword, {
    token,
    password,
});
export const logout = (to) => {
    authLib.logout().catch(() => { }); // best-effort server-side invalidation
    clearStorage();
    cache.nuke();
    location.replace(to || '/');
    return dispatch({ type: actionTypes.LOGOUT });
};
export const initiatePasswordReset = authLib.initiatePasswordReset;
export const updatePassword = authLib.updatePassword;
//# sourceMappingURL=actions.js.map